module.exports = __webpack_public_path__ + "img/shipo-icon-error.acac84b8.svg";